import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Content = styled.div.withConfig({
  displayName: "partials__Content",
  componentId: "sc-1hy7all-0"
})(["display:flex;flex-direction:row;wrap:nowrap;border-bottom:1px solid ", ";> :hover{background-color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiLL;
});
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1hy7all-1"
})(["display:flex;justify-content:space-between;width:100%;padding:6px 4px;cursor:pointer;"]);
export var Title = styled.h4.withConfig({
  displayName: "partials__Title",
  componentId: "sc-1hy7all-2"
})(["", ";font-weight:600;"], getFont(0));
export var DateBlock = styled.div.withConfig({
  displayName: "partials__DateBlock",
  componentId: "sc-1hy7all-3"
})(["", ";color:", ";"], getFont(-1), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.fontL;
});
export var LineContent = styled.div.withConfig({
  displayName: "partials__LineContent",
  componentId: "sc-1hy7all-4"
})([""]);
export var LineActions = styled.div.withConfig({
  displayName: "partials__LineActions",
  componentId: "sc-1hy7all-5"
})(["display:flex;align-items:center;"]);